















import { Component, Vue, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import * as _ from "lodash";

@Component
export default class AppParamsSearch extends Vue {
  internalValue = "";

  @Action("appParams/setAppParamsFormSearchValue")
  setAppParamsFormSearchValue?: (value: string) => void;

  debouncedSetValue = _.debounce(this.setSearchValue, 500);
  setSearchValue() {
    if (this.setAppParamsFormSearchValue) {
      this.setAppParamsFormSearchValue(this.internalValue);
    }
  }

  @Watch("internalValue", { immediate: true })
  internalValueWatch() {
    this.debouncedSetValue();
  }
}
